export default __webpack_public_path__ + "static/media/imdb.9e459aa7.png";